import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CreditCardIcon, ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
export function PayBillSection() {
  return <section className="py-16 md:py-20 bg-surface-muted" data-id="element-427">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-428">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-card shadow-card border border-gray-100 overflow-hidden" data-id="element-429">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 p-8 md:p-12" data-id="element-430">
            {/* Icon */}
            <div className="flex-shrink-0" data-id="element-431">
              <div className="w-20 h-20 rounded-full bg-brand-gold/10 flex items-center justify-center" data-id="element-432">
                <CreditCardIcon className="w-10 h-10 text-brand-gold" data-id="element-433" />
              </div>
            </div>

            {/* Content */}
            <div className="flex-grow text-center md:text-left" data-id="element-434">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-brand-dark mb-3" data-id="element-435">
                Pay Your Bill Online
              </h2>
              <p className="text-neutral-text/70 text-lg leading-relaxed max-w-xl" data-id="element-436">
                Make a secure payment from any of our 6 Maryland locations.
                Quick, easy, and convenient — pay your bill anytime, anywhere.
              </p>
              <div className="flex items-center gap-2 mt-3 justify-center md:justify-start text-sm text-neutral-text/50" data-id="element-437">
                <ShieldCheckIcon className="w-4 h-4 text-brand-gold" data-id="element-438" />
                <span data-id="element-439">Secure & encrypted payments</span>
              </div>
            </div>

            {/* CTA */}
            <div className="flex-shrink-0" data-id="element-440">
              <Link to="/payments" className="inline-flex items-center gap-2 bg-brand-dark hover:bg-brand-dark/90 text-white px-8 py-4 rounded-button font-heading font-semibold text-lg transition-colors shadow-sm focus-ring whitespace-nowrap" data-id="element-441">
                Pay Bill Now
                <ArrowRightIcon className="w-5 h-5" data-id="element-442" />
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}